import { Navigate, Outlet, useLocation } from "react-router-dom";
import { POST_LOGIN_PATHS } from "@crewledger/shared/beta-access";
import { useAuth } from "@/features/auth/auth-provider";

export function ProtectedRoute() {
  const { ready, provisioned, workspace, redirectTo, accessGate } = useAuth();
  const location = useLocation();

  if (!ready) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-sm text-muted-foreground">Loading…</p>
      </div>
    );
  }

  if (accessGate?.isPlatformAdmin && redirectTo === POST_LOGIN_PATHS.ADMIN) {
    return <Navigate to="/admin" replace />;
  }

  if (!provisioned) {
    return <Navigate to={redirectTo ?? POST_LOGIN_PATHS.REQUEST_ACCESS} replace />;
  }

  if (workspace?.needsOnboarding && workspace.type === "BETA" && !location.pathname.startsWith("/onboarding/beta")) {
    return <Navigate to="/onboarding/beta" replace />;
  }

  return <Outlet />;
}
